import { WriteRequest } from "~/backendApis/foundation/WriteRequest"

interface Params {
  selfIntroduction: string
}

export class ChangeSelfIntroductionWriteRequest extends WriteRequest<void> {
  private readonly endpoint: string =
    "/user_profile/user/edit/self_introduction/change"
  private readonly params: Params

  constructor(params: Params) {
    super()
    this.params = params
  }

  public post(): Promise<void> {
    return this.apiClient.post(this.endpoint, this.params)
  }
}
